import { AnnotationPlugin } from '@st/document-viewer-kit'
import { StampAnnotation } from '@st/sdk'
import { CrossReferencesToolState } from '~/st-doc-viewer/annotations'
import { copyToolState } from './tool-state'
import { CrossRefAnnotationElement, CrossRefToolOverlay } from './ui'

export { CrossRefToolEditor } from './ui'

export function crossReferencesPlugin(): AnnotationPlugin<
  StampAnnotation,
  CrossReferencesToolState
> {
  return {
    name: 'cross_references',
    initialToolState: {
      name: 'cross_references',
      settings: { templateId: undefined }
    },
    ToolOverlay: CrossRefToolOverlay,
    Element: CrossRefAnnotationElement,
    handlesAnnotation: (annotation) =>
      annotation.type === 'stamp' &&
      (annotation as StampAnnotation).stampType === 'cross_reference',
    onAnnotationSelected: (event) => {
      const annotation = event.annotationDraft ?? event.annotation
      if (annotation) {
        return { type: 'updateTool', tool: copyToolState(annotation as StampAnnotation) }
      }
      return null
    },
    onAnnotationDeselected: (event) => {
      if (event.annotationDraft)
        return { type: 'commitAnnotationDraft', annotationDraft: event.annotationDraft }
      return null
    }
  }
}
